new Swiper('.custom-our-best-sellers__slider-enable', {
	slidesPerView: 2,
	spaceBetween: 10,
     navigation: {
        nextEl: '.custom-our-best-sellers__slider-next',
        prevEl: '.custom-our-best-sellers__slider-prev',
    },
	breakpoints: {
		414: {
			slidesPerView: 2,
		},
		540: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 3,
			spaceBetween: 24,
		},
	},
});
